import React from "react";
import GlobalStyles from "./styles/GlobalStyles";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from "./components/Navbar";
import StorePage from "./pages/StorePage";
import { CartProvider } from "./context/CartContext";
import Cart from "./components/Cart";
import Checkout from "./pages/Checkout";
import Success from "./pages/Success";
import Cancelled from "./pages/Cancelled";
import NotFound from "./pages/NotFound";
import { SpeedInsights } from "@vercel/speed-insights/react"
import Footer from "./components/Footer";
import { Analytics } from "@vercel/analytics/react"

function App() {

  return (
    <CartProvider>
      <SpeedInsights />
      <Router>
        <GlobalStyles />
        <Navbar />
        <Cart />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<StorePage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancelled />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Analytics />

        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
